<div class="media" *ngIf="icon">
    <ng-content class="media-object" select="fui-icon"></ng-content>
</div>
<div class="label">
    <div class="label-title" id="label">
        {{title | translate}}
    </div>
</div>
<div class="toggle" *ngIf="toggle" select="fui-mark-toggle">
    <ng-content></ng-content>
</div>
